<app-form-question-container [name]="name" [questionId]="questionId" [tooltip]="tooltip">

  <alert [message]="questionAlertMessage()" alertType="info"></alert>

  <alert message="ConditionalRegistrationToSocialInsuranceInstitutionInfo" alertType="warning"></alert>

  @if (!fileInfoList || fileInfoList?.length < maxFileCount) {
    <div>
      <fileUpload
        [maxFileCount]="maxFileCount"
        [alreadySavedFiles]="fileInfoList"
        (onFilesChange)="onOptionChange($event)"
        [isDisabled]="isDisabled"
      ></fileUpload>
    </div>
  }

  @if (fileInfoList && fileInfoList?.length > 0) {
    <div class="wrapper">
      @for (file of fileInfoList; track file) {
        <div>
          <mat-icon>description</mat-icon>
          {{ file.OriginalName }}
          <br />
        </div>
      }
    </div>
  }

  @if (isCheckboxVisible()) {
    <mat-checkbox
      [disabled]="!newFile"
      color="primary"
      [ngModel]="has24hoursForApproval"
      (ngModelChange)="check($event)"
      [disabled]="isDisabled"
      >
      {{ 'FFQ-48HoursForFile' | translate }}
    </mat-checkbox>
  }
</app-form-question-container>